
import { computed } from "vue";
import { ActionTypes } from "../../../store/actions";
import Base from "../../base/Base.vue";
export default class MyChallenge extends Base {
  public myChallenge = computed(() => this.store.getters.getMyChallenge);
  created() {
    console.log(this.myChallenge);
  }

  removeChallenge(event: any, id: any) {
    this.store.dispatch(ActionTypes.REMOVE_CHALLENGE, id);
  }
}
